import { USER_ROLES } from 'app/services/users.service';

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.publisher;
}

export function permissionsRol(user) {
  return {
    sectionPersonalize: canPermissions(user),
  };
}
